import type { State } from '../types';
import { getCloudSiteOrOrgNameMap } from '../selectors/cloud-site-map-selector';
import { CloudSiteOrOrgNameMapGroupedByBillingProfile } from '../../ui/billing-profile/src/types';

// This method is used to get the available product ids for add all to cart
// based on applied filter on the billing profile and search query
export const getAvailableProductIdsForAddAllToCart = (state: State) => {
  // Get the cloud site map data based on filter billing profile and search query
  const cloudSiteOrOrgNameMapData = getCloudSiteOrOrgNameMap(state);

  // Get the cloud site map from the cloud site map data
  const { cloudSiteOrOrgNameMap } = cloudSiteOrOrgNameMapData ?? {};
  const filteredProductsIds = (() => {
    const cloudSiteOrOrgNameMapGroupedByBillingProfile = cloudSiteOrOrgNameMap as CloudSiteOrOrgNameMapGroupedByBillingProfile;

    const allProductIds = cloudSiteOrOrgNameMapGroupedByBillingProfile?.flatMap((site) => {
      // Get all the products from the cloud site map
      const products = Object.values(site.cloudSiteOrOrgNameMap || {})?.flatMap(
        (cloudSite) => cloudSite.products || []
      );
      return products?.map((product) => product.id);
    });
    return allProductIds;
  })();
  return filteredProductsIds ?? [];
};
